import api from "../service/camposDinamicos.service";
import * as types from "./camposDinamicos.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";
import camposDinamicosActions from "./camposDinamicos.actions";
import camposDinamicosSelector from "./camposDinamicos.selectors";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.GET_CAMPOS_DINAMICOS, getCamposDinamicos);
}

function* getCamposDinamicos() {
  const result = yield call(api.getCamposDinamicos);
  yield put(camposDinamicosActions.setCamposDinamicos(result.data));
}
